import React, { type ReactNode } from 'react';
import { SystemNotificationsContext } from './context';
import { useSystemNotificationsProvider } from './hooks';
interface SystemNotificationsProviderProps {
  children?: ReactNode;
}

const SystemNotificationsProvider = ({ children }: SystemNotificationsProviderProps) => {
  const value = useSystemNotificationsProvider();

  return (
    <SystemNotificationsContext.Provider value={value}>
      {children}
    </SystemNotificationsContext.Provider>
  );
};
export default SystemNotificationsProvider;
